export const getResourceParametrizedEndpoint = (
  resourceEndpoint: string,
  id: string
) =>
  resourceEndpoint.includes('crud')
    ? resourceEndpoint.replace('crud', `${id}/crud`)
    : `${resourceEndpoint}/${id}`
